import { render, staticRenderFns } from "./OrthoPriorTreatmentProvider.vue?vue&type=template&id=14e22c97&scoped=true"
import script from "./OrthoPriorTreatmentProvider.vue?vue&type=script&lang=js"
export * from "./OrthoPriorTreatmentProvider.vue?vue&type=script&lang=js"
import style0 from "./OrthoPriorTreatmentProvider.vue?vue&type=style&index=0&id=14e22c97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e22c97",
  null
  
)

export default component.exports